import { render, staticRenderFns } from "./CustomerPortfolio.vue?vue&type=template&id=172f0a16&scoped=true&"
import script from "./CustomerPortfolio.vue?vue&type=script&lang=ts&"
export * from "./CustomerPortfolio.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerPortfolio.vue?vue&type=style&index=0&id=172f0a16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172f0a16",
  null
  
)

export default component.exports